import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";

import { IPersonne } from "@/models/veos";

import Foot from "../../components/foot";
import Navbar from "../../components/navbar";
import template from "./home.vue";

import SignatureService from "@/services/signatureService";

/**
 * Home
 */
@Component({
  components: {
    Foot,
    Navbar,
  },
  mixins: [template],
})
export default class Home extends Vue {

  /** Services de signature électronique */
  @Inject() protected signatureService!: () => SignatureService;

  /** logo */
  protected logo: string = "/images/logo-def.png";
  /** personne */
  private personne: IPersonne = {};

  /**
   * Récupération des informations de la personne
   * @returns {string} personneDesc la description de la personne
   */
  get infosPer(): string {
    let desc: string|undefined = "";
    if (this.personne) {
      desc = this.personne.nom;
      if (this.personne.prenom) {
        desc += " " + this.personne.prenom;
      }
      desc += " (" + this.$t("components.dashboard.customer-internal-ref") + " " + this.personne.num + ")";
    }
    return desc ? desc : "";
  }

  /**
   * Initialisation de la vue
   */
  protected mounted() {
    if (this.$store.state.auth.url) {
      this.logo = `${this.$store.state.auth.url}rs/rsExtranet2/electronicSignature/logo`;
    }

    this.signatureService().getInfosPer().then(
      (data) => {
        this.personne = data.data;
      },
    );
  }
}
